<script>
    import PreviewComponent from "./PreviewComponent";
    import AvatarComponent from "components/pagesbuilder/dynamic-components/AvatarComponent";
    export default {
        name: "PreviewAvatarComponent",
        mixins: [PreviewComponent,AvatarComponent],
    }
</script>
